import { render, staticRenderFns } from "./reportePreciosTratamiento.vue?vue&type=template&id=cfd53eac&scoped=true"
import script from "./reportePreciosTratamiento.vue?vue&type=script&lang=js"
export * from "./reportePreciosTratamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd53eac",
  null
  
)

export default component.exports